"use client"

import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import api from "../utils/api"
import AdminDashboardView from "../components/views/admin/AdminDashboardView"
import AdminShell from "../components/admin/AdminShell"
import Skeleton, { SkeletonStatGrid, SkeletonList } from "../components/Skeleton"

function AdminPage() {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem("token")
      if (!token) return navigate("/login")

      try {
        const res = await api.get("/auth/me")
        const userData = res.data
        
        if (userData.role !== 'A') {
            navigate("/dashboard")
            return
        }
        
        setUser(userData)
      } catch (err) {
        console.error(err)
        localStorage.removeItem("token")
        navigate("/login")
      } finally {
        setLoading(false)
      }
    }

    fetchUser()
  }, [navigate])

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-green-50 font-sans">
        <div className="mx-auto max-w-6xl px-4 py-6" aria-busy="true" aria-label="Loading admin dashboard">
          <div className="flex items-center gap-3">
            <Skeleton className="h-12 w-12 shrink-0" rounded="rounded-2xl" />
            <div className="min-w-0 flex-1 space-y-2">
              <Skeleton className="h-5 w-48" />
              <Skeleton className="h-3 w-32" />
            </div>
          </div>
          <SkeletonStatGrid count={4} className="mt-5" />
          <SkeletonList rows={5} className="mt-4" />
        </div>
      </div>
    )
  }

  if (!user) return null

  return (
    <AdminShell user={user} title="Admin Dashboard" subtitle="Administrator Panel" maxWidth="max-w-7xl">
        <AdminDashboardView user={user} />
    </AdminShell>
  )
}

export default AdminPage
